/* jshint strict: true, quotmark: false, es3: true */
/* global $: false */

(function () {
  "use strict";

  function PDFRedact(pageView, pageRedactions) {
    if (!pageView) {
      return;
    }

    var page = $(pageView.el);
    this.container = page.find(".canvasWrapper");
    this.document = $(pageView.canvas);
    this.pageView = pageView;
    this.redactionsPending = false;
    this.pageNumber = pageView.id;
    this.canvas = window.current.document.createElement('canvas');
    this.canvas.width = this.document.width();
    this.canvas.height = this.document.height();
    this.canvas.style.position = "absolute";
    this.canvas.style.left = "0";
    this.canvas.style.top = "0";
    this.canvas.style.zIndex = 999999;
    this.canvas.id = "redaction" + pageView.id;
    this.active = false;

    this.container.append(this.canvas);

    this.stage = new createjs.Stage(this.canvas);

    this.stage.scaleX = pageView.scale;
    this.stage.scaleY = pageView.scale;

    this.pageRedactions = pageRedactions ? pageRedactions : [];
    this.active = false;
  }

  PDFRedact.prototype.mousedown = function (e) {
    this.isDown = true;
    var offset = this.getOffset(e);
    var x = offset[0];
    var y = offset[1];
    this.pageRedactions.push({x: x, y: y, width: 0, height: 0});
    this.draw();
  };

  PDFRedact.prototype.mouseup = function (e) {
    if (!this.isDown) {
      return;
    }
    var r = this.pageRedactions[this.pageRedactions.length - 1];
    var offset = this.getOffset(e);
    var x = offset[0];
    var y = offset[1];
    r.width = x - r.x;
    r.height = y - r.y;
    this.isDown = false;

    this.redactionsPending = true;

    this.pageRedactions = _.filter(this.pageRedactions, function (item) {
      return item.width !== 0 && item.height !== 0;
    });

    this.draw();

    if (r.width === 0 || r.height === 0) {
      return;
    }

    $(window.current.document).trigger("redactionsChanged");
  };

  PDFRedact.prototype.mousemove = function (e) {
    if (!this.isDown) {
      return;
    }
    var r = this.pageRedactions[this.pageRedactions.length - 1];
    var offset = this.getOffset(e);
    var x = offset[0];
    var y = offset[1];
    r.width = x - r.x;
    r.height = y - r.y;
    this.draw();
  };

  PDFRedact.prototype.activate = function () {
    $(this.canvas).on('mousedown', this.mousedown.bind(this));
    $(this.canvas).on('mouseup', this.mouseup.bind(this));
    $(this.canvas).on('mousemove', this.mousemove.bind(this));
    this.active = true;
  };

  PDFRedact.prototype.deactivate = function () {
    $(this.canvas).off('mousedown');
    $(this.canvas).off('mouseup');
    $(this.canvas).off('mousemove');
    this.active = false;
  };

  PDFRedact.prototype.dispose = function () {
    $(this.canvas).remove();
    this.document = null;
    this.container = null;
    this.stage = null;
    this.redactionsPending = null;
    this.pageView = null;
    this.pageRedactions = null;
  };

  PDFRedact.prototype.setup = function () {
    this.isDown = false;

    this.getOffset = function (e) {
      return [
        (e.offsetX || e.originalEvent.layerX) / this.pageView.scale,
        (e.offsetY || e.originalEvent.layerY) / this.pageView.scale
      ];
    };

    this.draw();
  };

  PDFRedact.prototype.draw = function () {
    var shape = null;
    var container = null;
    var text = null;

    var drawRedactions = function () {
      this.stage.removeAllChildren();
      for (var i = 0; i < this.pageRedactions.length; i += 1) {
        var width = this.pageRedactions[i].width;
        var height = this.pageRedactions[i].height;

        shape = new createjs.Shape();
        container = new createjs.Container();

        shape.index = i;
        shape.addEventListener("mousedown", function (event) {
          if (!this.active) {
            var yes = window.current.confirm("Do you want to remove the current redaction?");
            if (yes) {
              this.redactionsPending = true;
              this.pageRedactions = _.without(this.pageRedactions, this.pageRedactions[event.currentTarget.index]);
              drawRedactions();
              $(window.current.document).trigger("redactionsChanged");
            }
          }
        }.bind(this));

        shape.graphics.beginFill("#000").drawRect(0, 0, width, height);

        container.addChild(shape);

        container.x = this.pageRedactions[i].x;
        container.y = this.pageRedactions[i].y;

        this.stage.addChild(container);
      }

      this.stage.alpha = 1;

      this.stage.cache(0, 0, this.document.width() / this.stage.scaleX, this.document.height() / this.stage.scaleX, 0.75);

      this.stage.alpha = 0.7;

      this.stage.update();
    }.bind(this);

    if (this.pageRedactions === undefined) {
      return;
    }

    drawRedactions();
  };

  window.PDFRedact = PDFRedact;
}());
